
import React, { useState, useContext, useEffect } from 'react';
import Logo from '../assets/logo.png'; // Assuming you have a logo image in assets
import { AuthContext } from "../context/AuthContext";
import { Link, useNavigate, useLocation } from 'react-router-dom'; // Import Link from react-router-dom
import { FaSignOutAlt, FaUserTie } from 'react-icons/fa'; // Import FaSignOutAlt
import { get_new_leads_count_api } from '../controllers/dataController';


const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [newLeadsCount, setNewLeadsCount] = useState(0);
  const { isAuthenticated, isAdmin, logout } = useContext(AuthContext); // Destructure logout
  const navigate = useNavigate(); // Initialize navigate
  const location = useLocation();
  console.log("is Authenticated - ",isAuthenticated);
  console.log("is admin- ",isAdmin);

  useEffect(() => {
    if (isAuthenticated && isAdmin) {
        const fetchLeadsCount = async () => {
            try {
                const response = await get_new_leads_count_api();
                setNewLeadsCount(response.count);
            } catch (error) {
                console.error("Failed to fetch leads count", error);
            }
        };
        fetchLeadsCount();
        // Poll every minute for updates
        const interval = setInterval(fetchLeadsCount, 60000);
        return () => clearInterval(interval);
    }
  }, [isAuthenticated, isAdmin, location.pathname]); // Re-fetch on route change too, in case we just visited leads page (though optimizing to decrement local state would be better, polling is simple)


  const logoutUser = () => {
    if(logout()){
      navigate("/artist_login"); // Redirect to home or login page after logout
    }
  }

  const dashboardLink = isAuthenticated
    ? (isAdmin ? "/admin_dashboard" : "/dashboard")
    : "/artist_login";

  const dashboardText = isAuthenticated
    ? (isAdmin ? "Admin Dashboard" : "Dashboard")
    : "Account";

  return (
    <header className="sticky w-full bg-transparent bg-opacity-90 z-50 py-[40px] px-6 shadow-sm">
   
      <div className="max-w-4xl mx-auto flex justify-between items-center">
        {isAuthenticated ? (
          // Authenticated State: Logo, Dashboard Link, and Logout Icon
          <>
            <div className="flex items-center">
              <img src={Logo} alt="Logo" className="h-[43px] w-[70px] mr-3" />
              <div className="text-3xl tracking-[.25em] font-bold text-white">Baaj Media</div>
            </div>
            <div className="flex items-center space-x-6"> {/* Added flex container for dashboard link and logout */}
                <nav className="flex items-center space-x-6">
                    {isAdmin && (
                        <Link to="/leads" className="text-white hover:text-violet-200 font-medium transition-colors relative flex items-center gap-2" title="Leads">
                            <FaUserTie size={18} />
                            <span className="hidden md:inline">Leads</span>
                            {newLeadsCount > 0 && (
                                <span className="absolute -top-2 -right-2 bg-red-600 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full min-w-[18px] text-center">
                                    {newLeadsCount}
                                </span>
                            )}
                        </Link>
                    )}
                    <Link
                        to={dashboardLink}
                        className="text-white hover:text-violet-200 font-medium transition-colors"
                    >
                      {dashboardText}
                    </Link>
                </nav>
                <div onClick={logoutUser} title="Logout" className="cursor-pointer text-white"> {/* Added text-white for icon color */}
                    <FaSignOutAlt size={20} />
                </div>
            </div>
          </>
        ) : (
          // Not Authenticated State: Full Navigation
          <>
            <div className="flex items-center">
              <img src={Logo} alt="Logo" className="h-[43px] w-[70px] mr-3" />
              <div className="text-3xl tracking-[.25em] font-bold text-white">Baaj Media</div>
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex space-x-8">
              <a
                key={"home"}
                href="/"
                className="text-gray-700 hover:text-violet-200 font-medium transition-colors text-white"
              >
                Home
              </a>
             
              <a
                key={"account"}
                href={dashboardLink} // Use dashboardLink for "Account" section
                className="text-gray-700 hover:text-violet-200 font-medium transition-colors text-white"
              >
                {dashboardText}
              </a>
            </nav>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden text-gray-700"
              onClick={() => setMenuOpen(!menuOpen)}
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {menuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </>
        )}
      </div>

      {/* Mobile Menu (conditionally render based on isAuthenticated and menuOpen) */}
      {menuOpen && !isAuthenticated && ( // Only show mobile menu if not authenticated
        <div className="md:hidden mt-4 py-4 border-t">
          <div className="flex flex-col space-y-4 px-6">
            {['Home', 'Services', 'About', 'Portfolio', 'Contact'].map((item) => (
              <a
                key={item}
                href={`#${item.toLowerCase()}`}
                className="text-gray-700 hover:text-blue-600 font-medium"
                onClick={() => setMenuOpen(false)}
              >
                {item}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}

export default Header;